import { Component, inject } from '@angular/core';
import { WoodChainCustodyService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  WoodChainCustodyCreateDto,
  WoodChainCustodyDto,
  WoodChainCustodyExcelDownloadDto,
  WoodChainCustodyUpdateDto,
} from '../proxy/planning/dtos/wood-chain-custody';
import { WOODCHAINCUSTODY_CONFIG, WOODCHAINCUSTODY_FIELDS } from './wood-chain-custody.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-wood-chain-custody',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, WoodChainCustodyService, ConfirmationService],
  templateUrl: './wood-chain-custody.html',
  styleUrl: './wood-chain-custody.scss',
})
export class WoodChainCustody extends BaseCrudComponent<
  WoodChainCustodyDto,
  WoodChainCustodyCreateDto,
  WoodChainCustodyUpdateDto,
  WoodChainCustodyExcelDownloadDto
> {
  service = inject(WoodChainCustodyService);
  config = WOODCHAINCUSTODY_CONFIG;
  fields = WOODCHAINCUSTODY_FIELDS;

  protected prepareUpdateDto(data: any, selected: WoodChainCustodyDto): WoodChainCustodyUpdateDto {
    return {
      name: data.name,
      certificationType: data.certificationType,
      isCertified: data.isCertified,
      expirationDate: data.expirationDate,
      rowVersion: selected.rowVersion,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'WoodChainCustody';
  }
}
